import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material'
import { OrderJournalDialogProps } from './types'
import { useQuery } from 'react-query'
import { adminService } from 'shared/api'
import { GiftCardJournalTableItem } from './gift-card-journal-dialog-item'

function GiftCardJournalDialog({ open, onClose, giftCardId }: OrderJournalDialogProps) {
  const { data, isLoading } = useQuery(
    ['giftCardJournal', giftCardId],
    ({ signal }) => adminService.giftCard.getJournal(giftCardId, { signal }),
    { enabled: open }
  )

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Журнал событий</DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        {isLoading && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
            <CircularProgress />
          </div>
        )}
        {data?.data && (
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell align="left">Дата и время</TableCell>
                <TableCell align="left">Событие</TableCell>
                <TableCell align="left">Канал</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>{data.data.map?.((el) => <GiftCardJournalTableItem key={el.id} item={el} />)}</TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export { GiftCardJournalDialog }
